import React from 'react';
import _ from 'lodash';
import styled, { css } from 'styled-components';

const backgroundColorMapping = {
  danger: '#da5347',
  error: '#da5347',
  info: '#1b9edb',
  success: '#75ba50',
};

export const Container = styled.div`
  box-sizing: border-box;
  align-items: center;
  background-color: ${(props) => _.get(backgroundColorMapping, props.type, backgroundColorMapping.danger)};
  bottom: 0;
  display: flex;
  flex-direction: row;
  height: 61px;
  left: 0;
  justify-content: flex-start;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  padding: 15px;
  position: fixed;
  right: 0;
  top: -61px;
  transform: ${(props) => (props.visible ? 'translate3d(0, 61px, 0)' : 'translate3d(0, 0, 0)')};
  transition: 0.2s transform, 0.2s opacity;
  z-index: 9999;
  cursor: pointer;

  ${({ isIframe, iframeOffset, parentOffset }) =>
    isIframe &&
    css`
      position: absolute;
      top: ${parentOffset + iframeOffset - 61}px;
    `}
`;

export const IconContainer = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  display: flex;
  height: 32px;
  justify-content: center;
  margin-right: 15px;
  width: 32px;
`;

export const Message = styled.span`
  color: #fff;
  font-size: 14px;
  a {
    text-decoration: underline;
  }
`;

// margin-left: auto pins the button to the far right of the flex row without changing the
// icon/message layout; flex-shrink: 0 keeps it from collapsing under long messages.
export const DismissButton = styled.button`
  align-items: center;
  align-self: center;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  margin-left: auto;
  padding: 4px;

  &:focus-visible {
    border-radius: 3px;
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
`;

// font-awesome "times"
export function DismissIcon() {
  return (
    <svg aria-hidden='true' focusable='false' height='14' viewBox='0 0 1792 1792' width='14' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z'
        fill='currentColor'
      />
    </svg>
  );
}

export default { Container, IconContainer, Message, DismissButton, DismissIcon };
